<template>
  <q-option-group class="text-sm" size="sm" type="radio" dense inline>
    <template
      #label="{
        description,
        label,
        labelInfo,
        labelClass = 'q-mb-none text-weight-medium ',
        descriptionClass = 'q-mb-none text-neutral-70 text-xs',
      }"
    >
      <p :class="labelClass">
        {{ label }}

        <PTooltip v-if="labelInfo">{{ labelInfo }}</PTooltip>
      </p>
      <p :class="descriptionClass">
        {{ description }}
      </p>
    </template>
  </q-option-group>
</template>

<script setup></script>

<style lang="scss" scoped>
.q-option-group > :deep(div) {
  .q-radio--dense {
    align-items: start;

    &__inner {
      margin-top: 2px;
    }
  }
}
</style>
